import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { CoverImageSelector } from "../components/tree/coverImageSelector.js";
function mountCoverImageInput(el) {
    const input = $(el).hide();
    createRoot($("<div />").css("margin-top", "5px").insertAfter($(el)).get(0)).render(/*#__PURE__*/ _jsx(CoverImageSelector, {
        input: input,
        mountElement: el
    }));
}
export { mountCoverImageInput };
